import styled, { css } from 'styled-components';
import { IconButton } from '../../../../input/IconButton';
import { Flex, FlexProps } from '../../../../layout/Flex';

export const TextWrapper = styled(Flex)
    .withConfig({ displayName: 'CardActionsTextWrapper' })
    .attrs((props) => ({
        ...props,
        flexGrow: 1,
        borderRadius: 1.5,
        opacity: 0,
        py: 0.5,
        px: 1,
        backgroundColor: 'var(--content-overlay-medium)',
        transition: '.3s ease-out',
        display: { xs: 'none', sm: 'flex' },
        maxWidth: 'calc(100% - 38px)',
    }))``;

export const ActionsWrapper = styled(Flex)
    .withConfig({ displayName: 'CardActionsWrapper' })
    .attrs((props) => ({
        ...props,
        spacing: 1,
    }))``;

export const Button = styled(IconButton)
    .withConfig({ displayName: 'CardActionsButton' })
    .attrs((props) => ({
        ...props,
        variant: 'filled',
        size: 'm',
        padding: '6px',
        backgroundColor: 'var(--content-overlay-medium)',
    }))`
        backdrop-filter: none;
    `;

export const BookingButton = styled(IconButton)
    .withConfig({ displayName: 'CardActionsButton' })
    .attrs((props) => ({
        ...props,
        variant: 'filled',
        size: 'm',
        padding: '8px',
        backgroundColor: 'var(--content-overlay-medium)',
    }))`
    backdrop-filter: none;
`;

export const LeftBadgesWrapper = styled(Flex)
    .withConfig({ displayName: 'LeftBadgesWrapper' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        bottom: 0,
        left: 0,
        spacing: 1,
    }))``;

export const CardActionsWrapper = styled(Flex)
    .withConfig({ displayName: 'CardActions' })
    .attrs<FlexProps & { isMobile?: boolean | null }>((props) => ({
        ...props,
        cursor: 'pointer',
        alignItems: 'end',
        direction: 'row',
        justifyContent: 'end',
        spacing: 1,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: props.bottom || 0,
        left: 0,
        m: 1,
    }))`
        ${(props) =>
            !props.isMobile &&
            css`
                &:hover ${TextWrapper} {
                    opacity: 1;
                }

                &:hover ${LeftBadgesWrapper} {
                    opacity: 0;
                }
            `}
    `;
